export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const SET_IXIGO_SITE = 'SET_IXIGO_SITE'
export const UPDATE_LOCALE = 'UPDATE_LOCALE'
export const UPDATE_DISPLAY_CURRENCY = 'UPDATE_DISPLAY_CURRENCY'
export const SET_ALL_LANGUAGES = 'SET_ALL_LANGUAGES'
